<bs-modal size="lg" cssClass="customModal" #modal class="qrcode-modal" [keyboard]="false" [backdrop]="'static'">
  <bs-modal-body class="padding">

    <p class="closeBtn" (click)="close()"><i class="bi bi-x-lg"></i></p>
    <div class="wrapper">
      <div class="left-pan">
        <h2>Création du QR Code augmenté GS1</h2>
        <div class="first-section">
          <p><span>1. </span>Insérez l'URL de destination à encoder dans le QR Code.</p>
          <p><span>2. </span>Ajustez la taille du QR Code selon votre besoin.</p>
          <p><font>Vous pouvez le tester en le scannant avec votre téléphone</font></p>
          <p><span>3. </span>Appuyez sur le bouton « Télécharger » et utilisez votre QR Code (téléchargement au format
            SVG uniquement)</p>
        </div>
        <div class="second-section">
          <h3 class="padding">Recommandations GS1</h3>
          <div class="padding">
            En cette période de transition, le QR Code augmenté GS1 pourrait ne
            pas être lu en caisse. Par conséquent celui-ci devra être associé à un
            code-barres. Assurez-vous de bien respecter le placement de ces deux
            symboles. <br>
            <a href="https://www.gs1.fr/publication/guide-mise-oeuvre-codes-barres-2d-point-vente-du-commerce-detail"
               target=”_blank”>
              Consulter le guide (page 24)
              <i class="bi bi-arrow-right"></i>
            </a>
          </div>
          <h3 class="padding" >Impression et taille du QR Code</h3>
          <div class="padding">
            Pour une qualité optimale d’impression sur votre produit et la bonne
            lecture du QR Code, choisissez sa taille en respectant les limites fixées
            et veillez à ne pas déformer, étirer ou réduire l’image téléchargée : <br>
            <span class="text">
                Taille minimum 13,07 mm - taille maximum 32,7 mm <br>(zone de silence incluse).
              </span>
          </div>
        </div>
      </div>
      <div class="right-pan">
        <div class="loader" *ngIf="showLoader(); else hideLoader"
             gs1Spinner [big]="true" [size]="'80px'" [mainLoader]="true">
        </div>
        <ng-template #hideLoader>
          <div class="content">
            <div class="qr-code">
              <div class="loader-branding" *ngIf="previewQrcagBranding && formReady" gs1Spinner [big]="false" [size]="'20px'" [mainLoader]="false">
              </div>
              <img [src]="imageData" id="qrimage" alt="qr code" class="qr-code-preview"
                [class.without-branding]="!qrcagWithBrandingSelected" *ngIf="formReady && imageData && !previewQrcagBranding">

            </div>
            <div class="radio-group">
              <div id="notCompleteVCS" *ngIf="isVcs(); else isNotVCS">
                <div  [ngClass]="{ 'vcs--disabled': !isCompleteVcs() }">
                  <label class="radio" [class.disabled]="!isCompleteVcs()">
                    <input #radioDefaultURL
                          type="radio"
                          id="gs1"
                          name="choice"
                          [checked]="!isCustom"
                          [disabled]="!isCompleteVcs()"
                          (click)="setUrl(false)">

                    Utiliser l’URL de la page produit GS1 France
                    <span>En conformité avec la règlementation sectorielle en vigueur</span>


                    <span *ngIf="!isCompleteVcs()" class="tooltip">
                      Vous souhaitez utiliser la page produit GS1 France pour vous conformer aux exigences réglementaires ?<br>
                      Renseignez la liste des ingrédients et les valeurs nutritionnelles de votre produit en cliquant sur « Modifier ».
                    </span>
                    <img *ngIf="!isCompleteVcs()"
                    src="../../../../assets/img/lock-closed.svg"
                    alt="Lock icon"
                    class="lock-icon" />
                  </label>

                </div>
                <label class="radio">
                  <input #radioCustomURL type="radio" id="custom" name="choice" [checked]="isCustom" (click)="setUrl(true)">
                  Utiliser une autre URL
                  <span>Insérez le lien externe de votre choix (site web, page web, etc.)</span>
                </label>
              </div>
              <ng-template #isNotVCS>
                <div class="isNotCompleteVCS">
                  URL de destination
                </div>
                <div *ngIf="showUrlUpdateBlock()"  class="brand-alert-top">
                  <codification-rule class="brandAlerte codification-rule-text" title="Bon à savoir">
                    <div class="codification-rule-text">Lorsque vous modifiez l'URL de destination d’un QR Code augmenté GS1, celui-ci
                      est
                      automatiquement mis à jour. Il n’est donc pas nécessaire de le retélécharger
                    </div>
                  </codification-rule>
                </div>
              </ng-template>
              <div>
                <input [ngClass]="{'isNotEmpty': isEmptyUrl === false}" (keyup)="isEmptyUrl = false" type="url" placeholder="https://"
                       name="link" [pattern]="regEx" #link="ngModel" [(ngModel)]="customUrl" (focusout)="updateQRCAG(link, true)"
                       [appForbiddenUrls]="['codeonline-gtin.gs1.fr']" [hidden]="!isCustom" required>
                <div *ngIf="isCustom && link.invalid && (link.dirty || link.touched) && isEmptyUrl == false"
                     class="error-input">
                  Merci de renseigner une URL valide
                </div>
              </div>
              <div class="new-dimension-input">
                <label>Taille de téléchargement</label>
                <input [ngClass]="{'dimensions-class': isSizeEmpty() || sizeOutOFRange()}" type="number" #sizeInput="ngModel" name="dimensions" min="13.07" max="32.7" [(ngModel)]="size"
                       value="16.35" step="0.01" required>
                <div class="error-input" *ngIf="isSizeEmpty()">
                  Veuillez renseigner la taille de téléchargement
                </div>
                <div class="error-input" *ngIf="sizeOutOFRange()">
                  Veuillez saisir une taille comprise entre 13,07 et 32,7mm
                </div>
              </div>

            </div>
            <div  class ="branding" *ngIf="!this.productDoesNotHaveLink() && canSeeBrandingOption()">
              <div class="info-link-container">
                <Label> Faire figurer la marque GS1® </Label>
                <div class="info-icon-empty learnMore">?</div>
                <a href="https://www.gs1.fr/qr-codes-augmentes-gs1-marque-gs1r" target="_blank">
                  En savoir plus
                </a>
              </div>
              <div class="branding-radio-group">
                <label>
                  <input type="radio" name="brandGs1" [value]="true" [(ngModel)]="qrcagWithBrandingSelected" (change)="onBrandingClick(true)" >
                  Oui
                </label>
                <label>
                  <input type="radio" name="brandGs1" [value]="false" [(ngModel)]="qrcagWithBrandingSelected" (change)="onBrandingClick(false)" >
                  Non
                </label>
              </div>
              <div class="brand-info-container" *ngIf="isCustom">
                <div class="title">
                  <div class="info-icon-empty info">i</div>
                  <div > À propos de la marque GS1®</div>
                </div>

                <div class="brand-info-text">
                  Dans le cadre d’un pilote, vous avez la possibilité d’ajouter
                  la marque GS1® sur votre QR Code augmenté GS1, pour
                  <a [href]="listAuthorisedProductsBranding" target="_blank">une liste de produits retenus</a>.
                  Les modalités se trouvent dans nos
                  <a href="https://www.gs1.fr/sites/default/files/documents/2026-01/CGA%20GS1%20France%202026%204.pdf" target="_blank">Conditions Générales d’Adhésion</a>.
                </div>

              </div>
            </div>


            <div *ngIf="showUrlUpdateBlock() && isVcs()">
              <codification-rule class="brandAlerte" title="Bon à savoir">
                <div class="codification-rule-text">Lorsque vous modifiez l'URL de destination d’un QR Code augmenté GS1, celui-ci
                  est
                  automatiquement mis à jour. Il n’est donc pas nécessaire de le retélécharger.</div>
              </codification-rule>
            </div>
            </div>
          <div class="bottom-pan" *ngIf="!productDoesNotHaveLink()">
            <button type="button"  class="form-button" (click)="updateQRCAG(link)"

              [disabled]="(!showUrlUpdateBlock() || updatingLink) && !qrcagBrandingChanged() && !productDoesNotHaveLink()">
              Mettre à jour
            </button>
            <button type="button" class="form-button"

              [disabled]="!formReady || !imageData || !type || (!isValidLink && isCustom) || sizeInput.invalid || showUrlUpdateBlock() || qrcagBrandingChanged() || previewQrcagBranding"
              (click)="downloadQRCode()">
              Télécharger
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </bs-modal-body>
</bs-modal>
